import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface InformationCardProps {
  icon?: ReactNode
  text: string
  className?: string
}

export function InformationCard({
  icon,
  text,
  className,
}: InformationCardProps) {
  return (
    <div
      className={cn('flex items-center gap-2 px-4 py-3 rounded-md', className)}
    >
      {icon && <div className='flex-shrink-0'>{icon}</div>}
      <p className='text-sm'>{text}</p>
    </div>
  )
}
